import styled from 'styled-components';
import { COLOR_TOKEN } from '../../../helpers/color-tokens';

export const StyledIcon = styled.div`
	& svg:first-of-type {
		width: 60px;
		height: 60px;
		color: ${COLOR_TOKEN.content.primary};
	}

	@media (max-width: 960px) {
		& svg:first-of-type {
			width: 48px;
			height: 48px;
		}
	}

	@media (max-width: 375px) {
		display: none;
	}
`;

export const CalendarStyledIcon = styled(StyledIcon)`
	@media (max-width: 559px) {
		display: none;
	}
`;
